function createManagementActions({ location }) {
  return {
    LOGIN({ commit }, data) {
      commit('LOGIN', data.accesstoken);
      commit('SET_USER_INFO', data.userInfo);
    },
    LOGOUT({ commit }) {
      commit('LOGOUT');
      location.href = '/';
    },
    SET_NAVBAR({ commit }, data) {
      commit('SET_NAVBAR', data);
    },
  };
}

function createManagementMutations({ storage }) {
  return {
    LOGIN(state, data) {
      state.isLogin = true;
      storage.setItem('accesstoken', data);
    },
    SET_NAVBAR(state, data) {
      state.navbarState = data;
    },
  };
}

module.exports = { createManagementActions, createManagementMutations };
